export const ascendingKey = (number = 0) => {
  const currentTime = Date.now();
  const initialKey = currentTime + number;
  const initialKeyToSring = initialKey.toString();
  return initialKeyToSring;
};
